// extracted by mini-css-extract-plugin
module.exports = {"status":"lot-status_status__3bpjE"};